module.exports = __webpack_public_path__ + "img/amex.16b78605.svg";